export class FunnelSuccessionFilter {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get mixed() {
        return this.parent;
    }
    get app() {
        return this.mixed.app;
    }
    get filteredSuccessionMiniQuestions() {
        const { lastPosedAnswer } = this.app.tray.trayAnswers;
        if (!lastPosedAnswer || !lastPosedAnswer.miniQuestion) {
            return this.allMiniQuestions;
        }
        const { successionIndex } = lastPosedAnswer.miniQuestion.micro;
        const remaining = this.allMiniQuestions.filter(mini => mini.micro.successionIndex > successionIndex);
        if (remaining.length === 0) {
            return this.allMiniQuestions;
        }
        return remaining;
    }
    get allMiniQuestions() {
        return this.app.funnel.funnelIncoming.allMiniQuestions;
    }
}
